import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import MetricJobExperienceServices from "./MetricJobExperience.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getMetricJobExperience = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_METRIC_JOB_EXPERIENCE,
      payload: true,
    });
    let resp;
    if(filters.filter_2&& filters.filter_2!==""){
      resp = await MetricJobExperienceServices.getMetricJobExperience(filters);
    }
    const respAll = await MetricJobExperienceServices.getMetricJobExperience({
      filter_2: filters.filter_2,
    });
    const respAnio = await MetricJobExperienceServices.getMetricJobExperience();
    let temp = {data:[]};
    respAnio&&respAnio.data.data.map((item)=>{
      if(!temp.data.find(t=>t.anio===item.anio)){
        temp.data.push(item)
      }
    })
    dispatch({
      type: actions.GET_METRIC_JOB_EXPERIENCE,
      payload: {
        metricJobExperience:filters.filter_2&& filters.filter_2!==""?resp.data:{data:[],count:0},
        metricJobExperienceAll:respAll.data,
        metricJobExperienceAnio:temp
      },
    });
    dispatch({
      type: actions.METRIC_JOB_EXPERIENCE_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.METRIC_JOB_EXPERIENCE_FALLA,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_METRIC_JOB_EXPERIENCE,
      payload: false,
    });
  }
};

export const saveMetricJobExperience = (req, setShowModal, setInicialValorMinimo) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_METRIC_JOB_EXPERIENCE,
      payload: true,
    });
    const resp = await MetricJobExperienceServices.saveMetricJobExperience(req);
    const { data, count } = getState().metricJobExperience.metricJobExperience;
    const { data: dataAll, count: countAll } = getState().metricJobExperience.metricJobExperienceAll;
    const { data: dataAnio } = getState().metricJobExperience.metricJobExperienceAnio;
    const _data = [...data, resp.data];
    const _dataAll = [...dataAll, resp.data];
    let _dataAnio = dataAnio
    if(!_dataAnio.find(t=>t.anio===resp.data.anio)){
      _dataAnio.push(resp.data)
    }

    if(_dataAll[count]){
      setInicialValorMinimo(_dataAll[count].hasta + 1)
    }else{
      setInicialValorMinimo(0)
    }

    dispatch({
      type: actions.GET_METRIC_JOB_EXPERIENCE,
      payload: {
        metricJobExperience:{count: count + 1,data: _data},
        metricJobExperienceAll:{count: countAll + 1,data: _dataAll},
        metricJobExperienceAnio: {data: _dataAnio}
      },
    });
    dispatch({
      type: actions.FORM_METRIC_JOB_EXPERIENCE_FAIL,
      payload: "",
    });
    setShowModal(false);
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = ex.response.data[0];
            }
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_METRIC_JOB_EXPERIENCE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_METRIC_JOB_EXPERIENCE,
      payload: false,
    });
  }
};

export const editMetricJobExperience = (req, index, setShowModal, offset) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADER_METRIC_JOB_EXPERIENCE,
        payload: true,
      });
      const resp = await MetricJobExperienceServices.editMetricJobExperience(req.id, req);
      const { data, count } = getState().metricJobExperience.metricJobExperience;
      const { data: dataAll, count: countAll } = getState().metricJobExperience.metricJobExperienceAll;
      const { data: dataAnio } = getState().metricJobExperience.metricJobExperienceAnio;
      let _data = data.slice();
      let _dataAll = dataAll.slice();
      _data[index] = resp.data;
      _dataAll[index+offset] = resp.data;
      if(_dataAll[index+offset+1]){
        const _dataT = {
          de:_dataAll[index+offset].hasta+1
        }
        const _resp = await MetricJobExperienceServices.editMetricJobExperience(_dataAll[index+offset+1].id, _dataT);
        if(_data[index+1]){
          _data[index+1] = _resp.data;
        }
        _dataAll[index+offset+1] = _resp.data;
      }
      dispatch({
        type: actions.GET_METRIC_JOB_EXPERIENCE,
        payload: {
          metricJobExperience:{data: _data,count: count},
          metricJobExperienceAll:{data: _dataAll,count: countAll},
          metricJobExperienceAnio: {data: dataAnio}
        },
      });
      dispatch({
        type: actions.FORM_METRIC_JOB_EXPERIENCE_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = ex.response.data[0];
              }
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.FORM_METRIC_JOB_EXPERIENCE_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADER_METRIC_JOB_EXPERIENCE,
        payload: false,
      });
    }
  };

export const deleteMetricJobExperience = (item, index, offset, setInicialValorMinimo) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_METRIC_JOB_EXPERIENCE,
      payload: true,
    });
    await MetricJobExperienceServices.deleteMetricJobExperience(item.id);
    const { data, count } = getState().metricJobExperience.metricJobExperience;
    const { data: dataAll, count: countAll } = getState().metricJobExperience.metricJobExperienceAll;
    const { data: dataAnio } = getState().metricJobExperience.metricJobExperienceAnio;
    let _data = data.slice();
    let _dataAll = dataAll.slice();
    // let _dataAnio = dataAnio.slice();
    if(_dataAll[index+offset+1]){
      const _data1 = {
        de:_dataAll[index+offset].de
      }
      const _resp = await MetricJobExperienceServices.editMetricJobExperience(_dataAll[index+offset+1].id, _data1);
      if(index+1){
        _data[index+1] = _resp.data;
      }
      _dataAll[index+offset+1] = _resp.data;
    }
    _data.splice(index, 1);
    _dataAll.splice(index+offset, 1);

    if(_dataAll[count-2]){
      setInicialValorMinimo(_dataAll[count-2].hasta)
    }else{
      setInicialValorMinimo(0)
    }

    dispatch({
      type: actions.GET_METRIC_JOB_EXPERIENCE,
      payload: {
        metricJobExperience:{data: _data,count: count - 1},
        metricJobExperienceAll:{data: _dataAll,count: countAll - 1},
        metricJobExperienceAnio: {data: dataAnio}
      },
    });
    dispatch({
      type: actions.METRIC_JOB_EXPERIENCE_FALLA,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.METRIC_JOB_EXPERIENCE_FALLA,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_METRIC_JOB_EXPERIENCE,
      payload: false,
    });
  }
};
